import * as Services from "../models/swagger/generated-client-service";

export const ClientService = {
    me: Services.UsersService.me,

    myFirms: Services.FirmsService.my,

    firmAttorneys: Services.AttorneysService.firm,

    firmActiveAttorneys: Services.AttorneysService.firm1,

    getDocType: Services.RulesService.documenttype2,

    getAddresses: Services.RulesService.addresses,

    getFees: Services.RulesService.fees,

    getFirms: Services.FirmsService.firms,

    getParty: Services.RulesService.party,

    getCaseType: Services.RulesService.casetype,
    getDivision: Services.RulesService.division,
};

export const AttorneyService = {
    get: Services.AttorneysService.attorneys2,

    saveProfile: Services.AttorneysService.saveprofile,

    serviceContacts: Services.ServiceContactService.attorney,

    addServiceContacts: Services.ServiceContactService.serviceContact1,

    updateServiceContacts: Services.ServiceContactService.serviceContact3,

    deleteServiceContacts: Services.ServiceContactService.serviceContact4,

    saveAutomation: Services.AttorneysService.saveautomation,

    savePendingQueue: Services.AttorneysService.savependingqueue,

    saveService: Services.AttorneysService.saveservice,

    caseNumberRegex: Services.CaseNumberRegexService.attorney,
    addCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex1,
    updateCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex3,
    deleteCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex4,

    correctionQueue: Services.AttorneysService.correctionqueue,

    updateByDirectory: Services.AttorneysService.update,

    getBlackListEmail: Services.AttorneysService.getblacklist,
    addBlackListEmail: Services.AttorneysService.addblacklist,
    updateBlackListEmail: Services.AttorneysService.updateblacklist,
    deleteBlackListEmail: Services.AttorneysService.deleteblacklist,

    // -- ftp info
    singleFtpInfo: Services.FtpInfoService.single,
    getFTPInfo: Services.FtpInfoService.attorney,
    addFTPInfo: Services.FtpInfoService.create,
    updateFTPInfo: Services.FtpInfoService.update,
    deleteFTPInfo: Services.FtpInfoService.delete,
    // -- end ftp info

    //getPortalConfigurations: Services.AttorneysService.portalConfiguration,
};

export const PortalConfigurationService = {
    getList: Services.PortalConfigurationService.getlist,

    add: Services.PortalConfigurationService.add,

    update: Services.PortalConfigurationService.update,

    getCredentials: Services.PortalConfigurationService.getCredentials,

    clearCredentials: Services.PortalConfigurationService.clearCredentials,

    delete: Services.PortalConfigurationService.portalConfiguration4,
};

export const OrganizationService = {
    getList: Services.OrganizationsService.organizations,

    get: Services.OrganizationsService.organizations3,

    add: Services.OrganizationsService.organizations2,

    update: Services.OrganizationsService.organizations1,

    delete: Services.OrganizationsService.organizations4,

    users: Services.OrganizationsService.users,

    registerUser: Services.OrganizationsService.registerUser,

    firms: Services.OrganizationsService.firms,
    getFirmsFromOrg: Services.OrganizationsService.getFirms,
    isFileDrop: Services.OrganizationsService.fileDrop,
};

export const ProcessServerService = {
    getList: Services.ProcessServerService.processServer,
    add: Services.ProcessServerService.processServer1,
    get: Services.ProcessServerService.processServer2,
    update: Services.ProcessServerService.processServer3,
    delete: Services.ProcessServerService.processServer4,
};

export const AttorneyProcessServerService = {
    getList: Services.AttorneyProcessServerService.attorneyProcessServer,
    add: Services.AttorneyProcessServerService.attorneyProcessServer1,
    get: Services.AttorneyProcessServerService.attorneyProcessServer2,
    update: Services.AttorneyProcessServerService.attorneyProcessServer3,
    delete: Services.AttorneyProcessServerService.attorneyProcessServer4,
    getByAttorney: Services.AttorneyProcessServerService.attorney,
    getByProcessServer: Services.AttorneyProcessServerService.processserver,
};

export const UserService = {
    register: Services.UsersService.register,

    verify: Services.UsersService.verify,

    getList: Services.UsersService.users1,

    add: Services.UsersService.users,

    update: Services.UsersService.users2,

    delete: Services.UsersService.users4,

    roles: Services.RolesService.roles,

    me: Services.UsersService.me,

    forgotPassword: Services.UsersService.forgotPassword,

    resetPassword: Services.UsersService.resetPassword,

    sendEmail: Services.UsersService.sendRegistration,

    getAttorneys: Services.UsersService.getUserAttorneys,
    getAllAttorneys: Services.UsersService.getAllUserAttorneys,
    getUserAttorneysByFirm: Services.UsersService.getUserAttorneysByFirm,
    linkUserAttorneys: Services.UsersService.attorneys,

    resendConfirmationEmail: Services.UsersService.resendConfirmationCode,
};

export const DocumentRulesService = {
    getRule: Services.DocumentTypeRulesService.rule,

    getList: Services.DocumentTypeRulesService.attorney,

    update: Services.DocumentTypeRulesService.documentTypeRules3,

    add: Services.DocumentTypeRulesService.documentTypeRules1,

    delete: Services.DocumentTypeRulesService.documentTypeRules4,
};

export const CaseTypeRulesService = {
    getRule: Services.CaseTypeRulesService.rule,

    getList: Services.CaseTypeRulesService.attorney,

    update: Services.CaseTypeRulesService.caseTypeRules3,

    add: Services.CaseTypeRulesService.caseTypeRules1,

    delete: Services.CaseTypeRulesService.caseTypeRules4,
};

export const DivisionRulesService = {
    getRule: Services.DivisionRulesService.rule,

    getList: Services.DivisionRulesService.attorney,

    update: Services.DivisionRulesService.divisionRules3,

    add: Services.DivisionRulesService.divisionRules1,

    delete: Services.DivisionRulesService.divisionRules4,
};

export const CountyRulesService = {
    getRule: Services.CountyRulesService.rule,

    getList: Services.CountyRulesService.attorney,

    update: Services.CountyRulesService.countyRules3,

    add: Services.CountyRulesService.countyRules1,

    delete: Services.CountyRulesService.countyRules4,
};

export const MessageRulesService = {
    getRule: Services.MessageRulesService.rule,

    rule: Services.RulesService.messages,

    getList: Services.MessageRulesService.attorney,

    update: Services.MessageRulesService.messageRules3,

    add: Services.MessageRulesService.messageRules1,

    delete: Services.MessageRulesService.messageRules4,
};

export const FeeRuleService = {
    getRule: Services.FeeRuleService.rule,

    getList: Services.FeeRuleService.attorney,

    get: Services.FeeRuleService.feeRule,

    update: Services.FeeRuleService.feeRule3,

    add: Services.FeeRuleService.feeRule1,

    delete: Services.FeeRuleService.feeRule4,
};

export const TylerAdminService = {
    login: Services.AdminService.login,
    getUsers: Services.AdminService.users,
    addUser: Services.AdminService.users1,
    putUser: Services.AdminService.users2,
    getUser: Services.AdminService.users3,
    deleteUser: Services.AdminService.users4,
    getServiceContacts: Services.AdminService.serviceContacts,
    addServiceContact: Services.AdminService.serviceContacts1,
    updateServiceContact: Services.AdminService.serviceContacts2,
    deleteServiceContact: Services.AdminService.serviceContacts3,
    getAttorneys: Services.AdminService.attorneys,
    addAttorney: Services.AdminService.attorneys1,
    updateAttorney: Services.AdminService.attorneys2,
    getAttorney: Services.AdminService.attorneys3,
    deleteAttorney: Services.AdminService.attorneys4,
    getMyFirm: Services.AdminService.firm,
};

export const RequiredServiceDocumentRulesService = {
    getRule: Services.RequiredServiceDocumentRulesService.rule,

    getList:
        Services.RequiredServiceDocumentRulesService
            .requiredServiceDocumentRules,

    getByCounty: Services.RequiredServiceDocumentRulesService.county,

    findMatching: (params: {
        county?: string;
        caseNumber?: string;
        caseType?: string;
    }) =>
        Services.RequiredServiceDocumentRulesService.requiredServiceDocumentRules(
            {}
        ).then((resp) => {
            if (!resp.successful || !resp.data) return resp;
            const filtered = resp.data.filter((rule) => {
                const countyMatch =
                    !rule.county ||
                    (params.county &&
                        params.county
                            .toLowerCase()
                            .includes(rule.county.toLowerCase()));
                const caseNumberMatch =
                    !rule.containedInCaseNumber ||
                    (params.caseNumber &&
                        params.caseNumber
                            .toLowerCase()
                            .includes(
                                rule.containedInCaseNumber.toLowerCase()
                            ));
                const caseTypeMatch =
                    !rule.caseType ||
                    (params.caseType &&
                        params.caseType
                            .toLowerCase()
                            .includes(rule.caseType.toLowerCase()));
                return countyMatch && caseNumberMatch && caseTypeMatch;
            });
            return { ...resp, data: filtered };
        }),

    update: Services.RequiredServiceDocumentRulesService
        .requiredServiceDocumentRules3,

    add: Services.RequiredServiceDocumentRulesService
        .requiredServiceDocumentRules1,

    delete: Services.RequiredServiceDocumentRulesService
        .requiredServiceDocumentRules4,
};

export const ErrorDetailsRulesService = {
    getRule: Services.ErrorDetailsRulesService.rule,

    getList: Services.ErrorDetailsRulesService.errorDetailsRules,

    update: Services.ErrorDetailsRulesService.errorDetailsRules3,

    add: Services.ErrorDetailsRulesService.errorDetailsRules1,

    delete: Services.ErrorDetailsRulesService.errorDetailsRules4,
};

export const TylerPaymentService = {
    getAll: Services.TylerPaymentService.tylerPayment,
    get: Services.TylerPaymentService.tylerPayment3,
    add: Services.TylerPaymentService.tylerPayment1,
    link: Services.TylerPaymentService.link,
    update: Services.TylerPaymentService.tylerPayment2,
    delete: Services.TylerPaymentService.tylerPayment4,
};

export const MatterService = {
    getAllV2: Services.MatterManagmentService.org,
    get: Services.MatterManagmentService.populated,
    getV2: Services.MatterManagmentService.v21,
    addV2: Services.MatterManagmentService.v2,
    nextMatterV2: Services.MatterManagmentService.next,
    merge: Services.MatterManagmentService.merge,
    archive: Services.MatterManagmentService.v22,
    unarchive: Services.MatterManagmentService.v23,
    bulk: Services.MatterManagmentService.import,
    exportMatters: Services.MatterManagmentService.export,
    copyFrom: Services.MatterManagmentService.copyFrom,
    // template stuff ----------------------------------
    getAllTemplates: Services.MatterManagmentService.template1,
    addTemplate: Services.MatterManagmentService.template,
    updateTemplate: Services.MatterManagmentService.edit,
    archiveTemplate: Services.MatterManagmentService.template2,
    unarchiveTemplate: Services.MatterManagmentService.template3,
    deleteTemplate: Services.MatterManagmentService.del,
    // Cols -----------------------------------------------------
    getCols: Services.MatterManagmentService.cols,
    editCol: Services.MatterManagmentService.cols1,
    deleteCol: Services.MatterManagmentService.cols2,
    changeIdentifier: Services.MatterManagmentService.cols3,
};
